import {
    DATE_WISE_PRODUCTION_STOCK_REPORT_REQUEST,
    DATE_WISE_PRODUCTION_STOCK_REPORT_SUCCESS,
    DATE_WISE_PRODUCTION_STOCK_REPORT_FAILURE,
    DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_REQUEST,
    DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_SUCCESS,
    DATE_WISE_PRODUCTION_ROW_DETAIL_STOCK_REPORT_SUCCESS,
    DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_FAILURE
  } from "../types/date-wise-production-stock-report-types";
  
  const initialState = {
    dateWiseProductionStockReport: {},
    dateWiseProductionRowDetailStockReport: {},
    dateWiseProductionStockFilterReport: {},
    loading: false,
    error: null,
  };
  
  const dateWiseProductionStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case DATE_WISE_PRODUCTION_STOCK_REPORT_REQUEST:
      case DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case DATE_WISE_PRODUCTION_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          dateWiseProductionStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DATE_WISE_PRODUCTION_ROW_DETAIL_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          dateWiseProductionRowDetailStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          dateWiseProductionStockFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case DATE_WISE_PRODUCTION_STOCK_REPORT_FAILURE:
      case DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default dateWiseProductionStockReportReducer;
  